import { render, staticRenderFns } from "./RoleSelectionModal.vue?vue&type=template&id=b144df7a&scoped=true&"
import script from "./RoleSelectionModal.vue?vue&type=script&lang=js&"
export * from "./RoleSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelectionModal.vue?vue&type=style&index=0&id=b144df7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b144df7a",
  null
  
)

export default component.exports